import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";

interface UseGrantRxHistoryConsentParams {
  patientId: string;
  onSuccess?: () => void;
  onError?: () => void;
}

export const useGrantRxHistoryConsent = ({
  patientId,
  onSuccess,
  onError,
}: UseGrantRxHistoryConsentParams) => {
  const queryClient = useQueryClient();

  return useApiMutation<void, void>({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.MedicalRecords.RxHistory.GRANT_CONSENT(patientId),
      mutationFn: async () => {
        await axiosInstance.post(
          "/rx/medications/rx-history/consent",
          {},
          {
            params: { patientId: patientId },
          },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey:
            QueryKeys.Patient.MedicalRecords.RxHistory.DEFAULT(patientId),
        });
        onSuccess?.();
      },
      onError: () => {
        onError?.();
      },
    },
  });
};
